import React, { useCallback, useEffect } from "react";
import { columns } from "./columns.js";
import LocalTaxiIcon from "@material-ui/icons/LocalTaxi";
import RegularButton from "components/CustomButtons/Button.js";
import CardTable from "components/CardTable/CardTable.jsx";
import { useToggle } from "hooks/useToggle.js";
import { ModalV2 } from "components/Modal/ModalV2.jsx";
import { useDispatch, useSelector } from "react-redux";
import { taxiSelector } from "./selectors.js";
import { useSearch } from "hooks/useSearch.js";
import AddIcon from "@material-ui/icons/Add";
import {
  getTaxis,
  configPageTaxis,
  configPageTaxisSize,
  configFilterTaxis,
  configSortedTaxis,
} from "redux/actions/taxis/taxisActions.js";
import { TaxiInputs } from "./TaxiInputs.jsx";
import { TaxiForm } from "./TaxiForm.jsx";

export const TaxisView = () => {
  const taxis = useSelector(taxiSelector);
  const [open, setOpen] = useToggle();
  const dispatch = useDispatch();
  const { config: { filtered, page, pageSize, sorted }} = useSelector(({ taxis }) => taxis);
  const { isLoadingComp } = useSelector(
    ({ search }) => search
  );
  const { buildCompLoadings } = useSearch();

  const handleFilter = useCallback((e) => {
    dispatch(configFilterTaxis(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(configSortedTaxis(e));
  }, []);

  const handlePageOrders = useCallback((e) => {
    dispatch(configPageTaxis(e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(configPageTaxisSize(e));
  }, []);

  const handleGetNfcStatus = () => {
    // dispatch(getNfcTagsByStatus('', setOpen))
    setOpen()
  }

  useEffect(() => {
    taxis.length === 0 && dispatch(getTaxis());
    buildCompLoadings(["loadingTaxiAccounts", "loadingTaxiCustomer"]);
  }, []);

  return (
    <>
      <CardTable
        columns={columns}
        data={taxis}
        hasControl
        hasHeader
        icon={<LocalTaxiIcon />}
        title="Flotilla de Clientes"
        titleBlock
        blockBtn
        searchPanel
        filtered={filtered}
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePageOrders}
        onSortedChange={handleSort}
        isLoading={isLoadingComp?.loadingTaxis}
        tableContent={<TaxiInputs />}
        controls={
          <RegularButton
            round
            justIcon
            color="info"
            size="small"
            onClick={handleGetNfcStatus}
            tooltip="Agregar nuevo"
            loading={isLoadingComp?.loadingNfcTags}
          >
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
      />
      <ModalV2 open={open} onClose={setOpen} title="Registrar Flotilla">
        <TaxiForm onClose={setOpen} />
      </ModalV2>
    </>
  );
};
